"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var expressions_1 = require("../../types/expressions");
var schema = {
    $id: jsonschema_1.$id('findExpression'),
    title: expressions_1.ResolvedExpressionType.Find,
    type: 'object',
    properties: {
        $expression: {
            type: 'string',
            enum: [expressions_1.ResolvedExpressionType.Find]
        },
        array: {
            $ref: jsonschema_1.$id('arrayExpression')
        },
        condition: {
            anyOf: [
                { $ref: jsonschema_1.$id('functionExpression') },
                {
                    type: 'object',
                    nullable: true,
                    additionalProperties: false,
                    properties: {
                        query: {
                            $ref: jsonschema_1.$id('stringExpression')
                        },
                        match: {
                            $ref: jsonschema_1.$id('expression')
                        }
                    }
                }
            ]
        }
    },
    additionalProperties: false,
    required: ['$expression', 'array']
};
exports.default = schema;
//# sourceMappingURL=find.schema.js.map